<section class="about" id="about">
  <div class="container">
    <div class="about__grid">
      <div class="about__image fade-in">
        <img
          [ngSrc]="aboutImage()"
          [alt]="aboutImageAlt()"
          width="800"
          height="1000"
          priority
        />
      </div>
      <div class="about__text fade-in">
        <span class="section-subtitle">Rólunk</span>
        <h2 class="section-title">
          @if (profile()?.headline) {
            <span class="brand-name">{{ profile()?.headline }}</span>
          } @else {
            Otthonos vendéglátás Pákozdon, a Velencei-tó partján
          }
        </h2>
        <p>
          {{
            profile()?.descriptionPrimary ??
              'A Kanyar Büfé a Velencei-tó déli partján, Pákozdon kínál minőségi, hagyományos magyar konyhát. Híres pacalpörköltünk, frissen csapolt cseh sörök és nyugodt teraszunk teszi különlegessé a látogatást.'
          }}
        </p>
        <p>
          {{
            profile()?.descriptionSecondary ??
              'Minden fogásunk gondosan válogatott alapanyagokból, házias módszerrel készül — kirándulóknak, horgászoknak és helyieknek egyaránt.'
          }}
        </p>
        @if (showReservation()) {
          <a class="btn-outline" href="#reservation">Foglalj asztalt</a>
        }
      </div>
    </div>

    @if (features().length) {
      <div class="about__features">
        @for (feature of features(); track feature.id) {
          <div class="feature-card fade-in">
            <span class="feature-card__icon">{{ feature.icon }}</span>
            <h3 class="feature-card__title">{{ feature.title }}</h3>
            <p class="feature-card__description">{{ feature.description }}</p>
          </div>
        }
      </div>
    }
  </div>
</section>
